const IMAGES = {
  curriculos: "https://statics.coperdia.com.br/curriculos/img/curriculos.png",
  backgroundCadastro: "https://statics.coperdia.com.br/curriculos/img/background_login.png",
  recuperacaoSenha: "https://statics.coperdia.com.br/curriculos/img/recuperar_senha.png",
  backgroundHome: "https://statics.coperdia.com.br/curriculos/img/background_home.png",
  logoWhite: "https://statics.coperdia.com.br/curriculos/img/logo-coperdia-white.png",
  curriculoHome: "https://statics.coperdia.com.br/curriculos/img/curriculo_home.png",
  deletarConta: "https://statics.coperdia.com.br/curriculos/img/deletar_conta.png",
  consentimentos: "https://statics.coperdia.com.br/curriculos/img/consentimentos.png",
};

export { IMAGES };
